import React from 'react';
import PropTypes from 'prop-types';
import { StringConstantsMixin } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import MarketingModal from './MarketingModal';
import navigatorW622Src from './navigator-w622.jpg';
import navigatorW864Src from './navigator-w864.jpg';
import navigatorW864AvifSrc from './navigator-w864.avif';
import navigatorW622AvifSrc from './navigator-w622.avif';
import { EN_US } from '../../utils/constants/LanguageRegionCode';
import * as styles from './styles/styles.module.scss';
import { MEDIA_QUERY_SMALL_DOWN } from '../../utils/constants/breakpoints';

const {
  strings: {
    DOWNLOAD_THE_ALLTRAILS_APP,
    NAVIGATOR_MODAL: { NAVIGATOR_IS_ONLY, APP_ONLY_FEATURE, NAVIGATOR_ALT }
  }
} = StringConstantsMixin;

function NavigatorModal({ branchKey, languageRegionCode, mobileBrowser }) {
  const Picture = (
    <picture>
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={navigatorW622AvifSrc} type="image/avif" />
      <source media={MEDIA_QUERY_SMALL_DOWN} srcSet={navigatorW622Src} />
      <source srcSet={navigatorW864AvifSrc} type="image/avif" />
      <img alt={NAVIGATOR_ALT} className={styles.img} src={navigatorW864Src} />
    </picture>
  );

  if (languageRegionCode === EN_US) {
    return (
      <MarketingModal
        branchKey={branchKey}
        headerText={DOWNLOAD_THE_ALLTRAILS_APP}
        instructionsText={NAVIGATOR_IS_ONLY}
        languageRegionCode={languageRegionCode}
        mobileBrowser={mobileBrowser}
        picture={Picture}
      />
    );
  }

  return (
    <MarketingModal
      branchKey={branchKey}
      headerText={APP_ONLY_FEATURE}
      instructionsText={NAVIGATOR_IS_ONLY}
      languageRegionCode={languageRegionCode}
      mobileBrowser={mobileBrowser}
      picture={Picture}
    />
  );
}

NavigatorModal.propTypes = {
  branchKey: PropTypes.string.isRequired,
  languageRegionCode: PropTypes.string.isRequired,
  mobileBrowser: PropTypes.bool.isRequired
};

export default NavigatorModal;
